import styled from "styled-components";
import { palette } from "styled-theme";

const ToDoListWrapper = styled.div`
  // position: absolute;
  // bottom: 0;
  // left: 0;
  height: 100%;

  .menu {
    filter: drop-shadow(1px 1px 1px #adadad);
    width: 300px;
  }
  .container {
    min-width: 400px;
    background: #ffffff;
    height: 100%;

    // position: absolute;
    // left: 10px;
    // bottom: 44px;
  }
  .todolist_header {
    background: #5950ec;
    border-bottom: 1px solid rgba(5, 5, 5, 0.06);
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
  }
  .ant-menu-light.ant-menu-root.ant-menu-inline,
  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border: none;
  }
  .ant-layout-sider-trigger {
    background: transparent;
    bottom: 0px;
    color: #5950ec;
    border-top: 1px solid rgba(5, 5, 5, 0.06);
  }
  .sidebar-seperator {
    margin: 10px 0;
    width: 100%;
    height: 1px;
    background: rgba(5, 5, 5, 0.06);
  }

  .todo_button {
    -webkit-appearance: button;
    background: #ffffff;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
  }

  .todo_button path {
    fill: #00b96b;
  }

  .tasks {
    ul {
      padding: 0;
      margin: 5px 0 0 0;
    }
    li {
      list-style-type: none;
    }
  }
  .task_inner {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .task_top {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .task_relations {
    display: flex;
    align-items: center;
  }
  .task_item {
    display: flex;
    padding: 8px;
    border: 1px solid #5950ec2e;
    margin: 0 0 10px 0;
    border-radius: 5px;
    background: #ffffff;
    .task_name {
      // color: #ffffff;
    }
    .task_bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .item-horizontal-seperator {
    width: 10px;
    hright: 10px;
  }
  .star_component {
    .ant-rate-star-first {
      width: 100%;
      opacity: 1;
    }
  }
`;

export default ToDoListWrapper;
